import { gql } from '@apollo/client';

export const GET_TXIMPORT_PREVIEW = gql`
  query GetTxImportPreview($jobId: ID!, $limit: Int, $offset: Int, $onlyInvalid: Boolean) {
    tximportPreview(jobId: $jobId, limit: $limit, offset: $offset, onlyInvalid: $onlyInvalid) {
      total
      readyCount
      mappingPlan {
        sourceFormat
        fields {
          targetField
          columns
          strategyKind
        }
      }
      items {
        id
        jobId
        portfolioId
        tokenId
        token {
          id
          ticker
          name
        }
        rawTicker
        rawCoingeckoId
        rawLocation
        rawSourceLocation
        rawDestinationLocation
        resolvedTokenName
        transactionType
        price
        quantity
        timestamp
        fees
        feeQuantity
        notes
        skipped
        currency
        brokerBaseCurrency
        brokerFXRate
        brokerBaseAmount
        fxRateToUSD
        fxSource
        originalRow
        createdAt
        updatedAt
        isValid
        validationErrors {
          field
          message
        }
        stockId
        rawIsin
        rawExchange
      }
      job {
        id
        portfolioId
        status
        stage
        updatedAt
        ... on TxImportJob {
          assetKind
          importSource
        }
      }
    }
  }
`;

export const GET_TXIMPORT_RESULT = gql`
  query GetTxImportResult($jobId: ID!) {
    tximportResult(jobId: $jobId) {
      jobId
      portfolioId
      status
      stage
      error
      assetKind
      summary {
        total
        imported
        duplicates
        insufficient
        userSkipped
        invalid
        pending
      }
    }
  }
`;

export const GET_TXIMPORT_RESULT_ROWS = gql`
  query GetTxImportResultRows($jobId: ID!, $status: TxImportRowStatus, $limit: Int, $offset: Int) {
    tximportResultRows(jobId: $jobId, status: $status, limit: $limit, offset: $offset) {
      items {
        id
        tokenId
        token {
          id
          ticker
          name
          coingeckoSlug
        }
        transactionType
        price
        quantity
        timestamp
        fees
        feeQuantity
        currency
        brokerBaseCurrency
        brokerFXRate
        brokerBaseAmount
        fxRateToUSD
        fxSource
        rawLocation
        rawSourceLocation
        rawDestinationLocation
        originalRow
        isValid
        importStatus
        importedTransactionId
        importError
        validationErrors {
          field
          message
        }
        stockId
        rawIsin
        rawExchange
      }
      total
      hasMore
    }
  }
`;

